import { HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd";

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    private requests: HttpRequest<any>[] = [];
    private loadingMessageId: string | null = null;

    constructor(private messageService: NzMessageService) { }

    addRequest(req: HttpRequest<any>) {
        this.requests.push(req);
        this.showLoadingMessage();
    }

    removeRequest(req?: HttpRequest<any>) {
        if (req) {
            const index = this.requests.indexOf(req);
            if (index >= 0) {
                this.requests.splice(index, 1);
            }
        } else {
            // If no specific request is provided, clear all
            this.requests = [];
        }
        this.hideLoadingMessageIfNecessary();
    }

    private showLoadingMessage() {
        if (this.requests.length === 1 && !this.loadingMessageId) {
            setTimeout(() => {
                if (this.requests.length > 0 && !this.loadingMessageId) {
                    this.loadingMessageId = this.messageService.loading("Učitavanje...", { nzDuration: 0 }).messageId;
                }
            }, 200);
        }
    }

    private hideLoadingMessageIfNecessary() {
        if (this.requests.length === 0 && this.loadingMessageId) {
            this.messageService.remove(this.loadingMessageId);
            this.loadingMessageId = null;
        }
    }
}